import store from '@/store'
import RoomAvatar from './RoomAvatar.js'
import ChatImg from '@/views/room/IM/MessageList/components/common/ChatImg.js'
import RedNum from "_com/func/RedNum.vue";
import unread from '_lib/unreadState';
import badger from "_lib/Badger"
import Vue from 'vue';
import roomItemRenderInstance from './roomItemRender.js'
import { initTooltip, updateTooltip } from './tooltip.js'
import { checkIsMute } from '@/common/notifySettings'

class FolderItemRenderer {
  constructor(props) {
    this.resetData(props);
    this.index = null
    this.baseEl = null;
    this.roomAvatars = new Map();
    this.mpImgs = new Map();
  }
  get props_data() {
    return this.props.data;
  }
  get hasRedPoint() {
    if (this.props.folderType !== 'mini') {
      return false
    }
    return !this.data.isOpen && this.props_data.mini_programs.some(v => v.is_new)
  }
  resetData (props) {
    this.props = this.initProps(props);
    this.data = this.initData();
  }
  initProps (args) {
    return {
      data: args.data || {},
      index: args.index || null,
      folderType: args.folderType || 'room',
      getRefFunc: args.getRefFunc || (() => {}),
      isCurFolder: args.isCurFolder || false,
      contextFunc: args.contextFunc || (() => {}),
      isDefaultOpen: args.isDefaultOpen || false,
      draggable: args.draggable === undefined ? true : args.draggable,
    }
  }
  initData () {
    const data = {
      isOpen: false,
      isOpenAnimation: false,      // 添加：控制高度动画
      isAnimationOver: true,       // 添加：标记动画是否结束
      _animationTimer: null,       // 添加：存储定时器ID
      domHeight: 42,
      mouseMoveIn: false,
      refList: [],
    };
    switch (this.props.folderType) {
      case "room":
        data.folderAttrName = "rooms";
        data.idAttrName = "room_id";
        data.dragName = "dragleroom";
        data.tooltipClass = "tooltip-roombar-text";
        break;
      case "mini":
        data.folderAttrName = "mini_programs";
        data.idAttrName = "id";
        data.dragName = "draglemp";
        data.tooltipClass = "tooltip-mpbar-text";
        break;
    }
    if (this.props.isDefaultOpen) {
      data.isOpen = true
      data.isOpenAnimation = true
    }
    return data;
  }
  getData(id) {
    return this.folders.get(id);
  }
  setData(id, data) {
    this.folders.set(id, data);
  }
  render ({index}) {
    if (!this.data) {
      return '';
    }
    if (index !== undefined) {
      this.index = index;
    }
    const html = `
      <div
        class="${this.initBaseElClass()}"
        data-folder-id="${this.props_data.folder_id}"
        data-delegate-dragenter-folder
        data-delegate-dragover-folder
        data-delegate-dragleave-folder
        data-delegate-drop-folder
        data-delegate-ctxmenu-folder
      >
        <div class="folder-bg"></div>
        <div class="folder-guild">
          <div class="folder-guid-outer transition-transform duration-200 relative">
            <div class="folder-guild-contain">
              ${this.renderGuildWrapper()}
            </div>
            ${this.renderRoomStatus()}
          </div>
        </div>
        ${this.renderRoomList()}
      </div>
    `
    return html;
  }
  initBaseElClass() {
    let classStr = 'cpt-folder-wrapper w-full relative';
    if (this.data.isOpen) {
      classStr += ' open';
    }
    if (!this.data.isOpen) {
      if (this.props.isCurFolder) {
        classStr += ' active';
      }
      if (this.data.mouseMoveIn) {
        classStr += ' scale-up';
      }
    }
    if (this.props.folderType) {
      classStr += ` ${this.props.folderType}`;
    }
    if (this.hasRedPoint) {
      classStr += ' has-red-point';
    }
    return classStr;
  }
  initEvents() {
    const baseEl = this.getBaseEl(this.props_data.folder_id);
    const avatars = [...this.roomAvatars.values()];
    for (let i = 0; i < avatars.length; i++) {
      const el = baseEl.querySelector(`.cpt-chat-room-avatar:nth-child(${i + 1})`);
      el && avatars[i].initEvents(el)
    }
    for (let img of this.mpImgs.values()) {
      img.initEvents(baseEl)
    }
    if (this.data.isOpen) {
      this.props_data.rooms.forEach(item => {
        roomItemRenderInstance.initEvents({room: item})
      })
    }
    const shortcutBlock = baseEl.querySelector('.shortcut-block');
    shortcutBlock && initTooltip(shortcutBlock, this.getTooltipData(this.props_data));
  }
  getTooltipData (folderData) {
    return {
      text: folderData.folder_name || folderData.rooms.map((v) => v.room_name).join(","),
      placement: 'right',
      popperClass: 'room-shortcut-tooltip',
    }
  }
  getFolderStateIconClass () {
    // 房间活动 > 开黑邀约 > 屏幕共享 > 伴奏 > 语音
    let icon_order = [
      "icon-speak-on",
      "icon-music",
      "icon-pcshare",
      "icon-fight",
      'icon-calendar',
    ];
    let icon_type = "", icon_active = false;
    this.props_data.rooms.forEach((room) => {
      let room_type, room_active;
      if(room.room_act_info) {
        room_type = "icon-calendar"
      } else if (room.promise_info) {
        room_type = "icon-fight";
      } else if (room.screen_share_members?.length > 0) {
        room_type = "icon-pcshare";
      } else if (room.audio_share_members?.length > 0) {
        room_type = "icon-music";
      } else if (room.audio_count) {
        room_type = "icon-speak-on";
      }
      if (checkIsMute(room.room_id)) {
        room_type = ''
      }
      if (!store.getters.channel_connecting && store.getters.cur_channel_data.room_id == room.room_id) {
        room_active = true;
      }
      if (room_active && !icon_active) {
        icon_active = true;
        icon_type = room_type;
      } else if (icon_order.indexOf(room_type) > icon_order.indexOf(icon_type)) {
        icon_type = room_type;
      }
    });
    if (icon_type) {
      return icon_type + (icon_active ? " active" : "");
    }
  }
  updateFolderNameTooltip(folderData) { 
    const el = this.getBaseEl(this.props_data.folder_id).querySelector('.shortcut-block');
    el && updateTooltip(el, this.getTooltipData(folderData))
  }
  updateFolderBgColor (folderData) {
    const el = this.getBaseEl(this.props_data.folder_id).querySelector('.folder-guild-wrapper');
    el && (el.style.backgroundColor = folderData.color ? `${folderData.color}66` : '')
  }
  getBaseEl(folderId) {
    return document.querySelector(`.cpt-folder-wrapper[data-folder-id="${folderId}"]`);
  }
  destroyRoom(room_id) {
    const baseEl = this.getBaseEl(this.props_data.folder_id);
    const el = baseEl.querySelector(`[data-room-id="${room_id}"]`);
    if (el) {
      el.remove();
    }
  }
  destroy({room_id, folder_id}) {
    if (folder_id !== this.props_data.folder_id) {
      return;
    }
    const baseEl = this.getBaseEl(this.props_data.folder_id);
    if (this.data.isOpen) {
      const roomItemEl = baseEl.querySelector(`.cpt-shortcut-block-wrapper[data-room-id="${room_id}"]`);
      if (roomItemEl) {
        roomItemRenderInstance.destroy({room_id});
        roomItemEl.remove();
        const itemHeight = 54; // 每个房间项的高度
        const rooms = (this.props_data.rooms || []).filter(v => v.room_id !== room_id);
        if (rooms.length === 0) {
          baseEl.remove();
        } else {
          const roomListEl = baseEl.querySelector('.folder-room-list');
          const height = this.data.isOpenAnimation ? itemHeight * rooms.length + 4 + 'px' : '0px';
          roomListEl.style.height = height;
        }
      }
    } else {
      const avatars = [...this.roomAvatars.values()];
      if (room_id) {
        const roomAvatar = this.roomAvatars.get(room_id);
        if (roomAvatar) {
          roomAvatar.destroy(baseEl)
        }
        this.roomAvatars.delete(room_id)
      } else {
        for (let i = 0; i < avatars.length; i++) {
          const el = baseEl.querySelector(`.cpt-chat-room-avatar:nth-child(${i + 1})`);
          el && avatars[i].destroy(el)
        }
      }
      
      for (let img of this.mpImgs.values()) {
        img.destroy(baseEl)
      }
      this.roomAvatars.clear()
      this.mpImgs.clear()
    }
    this.props_data.rooms = this.props_data.rooms.filter(v => v.room_id !== room_id);
  }
  renderGuildWrapper() {
    const html = `
      <div
        class="folder-guild-wrapper"
        style="${this.props_data.color ? `background-color: ${this.props_data.color}66` : ''}"
        data-delegate-click-folder
      >
        <div
          class="shortcut-block ${this.props.folderType === 'room' ? 'folder-items' : 'mp-folder-item'}"
          ${this.props.draggable ? `draggable="true"` : ''}
          data-delegate-dragstart-folder
        >
          ${this.renderGuildInnerImgs()}
        </div>
        <div class="folder-icon">
          <i class="iconfont icon-file" :style="color:${this.props_data.color}"></i>
        </div>
      </div>
    `
    return html;
  }
  renderGuildInnerImgs () {
    if (this.props.folderType === 'room') {
      return this.renderRoomInnerImgs();
    }
    return this.renderMpInnerImgs();
  }
  renderRoomInnerImgs () {
    let html = ''
    const avatars = this.props_data[this.data.folderAttrName]?.slice(0, 4) || [];
    avatars.forEach(item => {
      const avatar = new RoomAvatar({
        room_name: item.room_name,
        img: item.room_avatar,
        only_one_char: true,
        width: 16,
        icon_width: 12,
        webp_quality: 50,
        customAttr: `data-room-id="${item.room_id}"`
      });
      this.roomAvatars.set(item.room_id, avatar);
      html += avatar.render();
    })
    return html;
  }
  renderMpInnerImgs () {
    const mpImgs = this.props_data.mini_programs?.slice(0, 4);
    if (!mpImgs) return '';
    let html = ''
    mpImgs.forEach(item => {
      const chatImg = new ChatImg({
        src: item.channel_icon ||item.avatar,
        classList: ['flex-center', '!w-[12px]', '!h-[12px]'],
      });
      this.mpImgs.set(item.mini_pro_id, chatImg);
      html += chatImg.render();
    })
    return html;
  }
  renderRoomStatus () {
    let html = ''
    if (!this.data.isOpen) {
      html = this.renderRedNum(this.data);
      html += this.renderFolderStateIcon();
    }
    return html;
  }
  renderFolderStateIcon () {
    const folderStateIconClass = this.getFolderStateIconClass();
    let html = ''
    if (folderStateIconClass) {
      html = `<i class="iconfont folder-speak flex-center w-[22px] h-[22px] absolute right-[-6px] top-[-6px] bg-fl-btn text-tx-1 z-[102] rounded-full ${folderStateIconClass}"></i>`
    }
    return html
  }
  renderRoomList () {
    let html = ''
    if (this.data.isOpen) {
      this.props_data.rooms.forEach((item, index) => {
        html += roomItemRenderInstance.render({
          room: item,
          folder_id: this.props_data.folder_id,
          className: 'folder-inner-room',
          index,
          draggable: this.props.draggable
        })
      })
      html = `
        <div class="folder-room-list">
          ${html}
        </div>
      `
    }
    return html
  }
  renderRedNum() {
    const unreadState = this.unreadState();
    const show_theme_data = store.getters.show_theme_data;
    if (unreadState.redCount) {
      const RedNumCtr = Vue.extend(RedNum);
      const redNumEl = new RedNumCtr({
        propsData: {
          borderColor: show_theme_data.bar_color ? show_theme_data.bar_color[0] : '',
          isHasBorder: true,
          num: unreadState.redCount,
        },
      });
      return redNumEl.$mount().$el.outerHTML;
    } else if (unreadState.showRedPoint) {
      const style = show_theme_data.bar_color ? ` style="border-color:${show_theme_data.bar_color[0]}"` : '';
      return `<div class="red-point"${style}></div>`;
    }
    return '';
  }
  unreadState() {
    let obj = {
      redCount: 0,
      showRedPoint: false,
    };
    this.props_data.rooms.forEach((v) => {
      let { redCount, showRedPoint } = unread.getUnreadState({ room_id: v.room_id }, true);
      if (window.client_env !== 'electron') {
        badger.updateRoomUnreadCount(redCount, v.room_id);
      }
      obj.redCount += redCount;
      obj.showRedPoint = showRedPoint || obj.showRedPoint;
    });
    return obj;
  }
  
}

export default FolderItemRenderer;